import { mapActions, mapState } from 'vuex';
import { PaymentTypeClient } from '@/utils/enums/paymentMagicNumberEnum';

export default {
  name: 'updatePaymentToPrivate',
  computed: {
    ...mapState({
      paymentData: ({ currentAdmission }) => currentAdmission.data.payments[0],
    }),
  },
  methods: {
    ...mapActions([
      'updateAdmissionPaymentCommand',
    ]),
    async updatePaymentToPrivate() {
      const { value, status, uuid } = this.paymentData;

      const payload = {
        clientId: PaymentTypeClient.PRIVATE,
        details: {
          type: 'PRIVATE',
          cardNumber: null,
          negotiationVariables: null,
          cardExpirationDate: null,
        },
        status,
        value,
        uuid,
      };

      try {
        await this.handlePayment_mixin(payload);
      } catch (err) {
        this.$router.push({
          name: 'payment-error-service-desk',
        });
        throw err;
      }
    },
  },
};
